import styled from 'styled-components';
import PriceCalendarBody from './body';
import PriceCalendarHeader from './header';
import { PriceCalendarBodyProps } from './types';

const Container = styled.table`
  width: min-content;
  margin: auto;
  border-collapse: separate;
  border-spacing: 0 var(--size-tiny);
`;

type PriceCalendarProps = PriceCalendarBodyProps;

const PriceCalendar = (props: PriceCalendarProps) => {
  const { destination, origin, setCheapestDate } = props;

  return (
    <Container>
      <PriceCalendarHeader />
      <PriceCalendarBody
        destination={destination}
        origin={origin}
        setCheapestDate={setCheapestDate}
      />
    </Container>
  );
};

export default PriceCalendar;
